import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Register service worker so the PWA install prompt becomes available
// (Chromium requires a registered SW with a fetch handler). We register
// AFTER first paint to avoid blocking the critical render path.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* silent fail — SW is progressive enhancement only */
    });
  });
}
